import { defineStore } from "pinia";
import { ref } from "vue";

export const useEnvironmentStore = defineStore("environment", () => {
    const api = ref<string>();
    const assets = ref<string>();

    function inject(args: { apiEndpoint: string; assetsEndpoint: string }) {
        api.value = args.apiEndpoint;
        assets.value = args.assetsEndpoint;
    }

    return { api, assets, inject };
});
